// The Overview's quota tile (NAV-002, SCR-234, REQ-088): how many organizations have a quota
// exhausted, in grace or past a warning right now, with a link to the fleet view. TASK-257 mounts
// it on the Overview for a principal with `billing:read`. Like the Overview's other parts, a
// refused or failed read leaves the tile out rather than showing a banner; the API's 501 placeholder
// shows a one-line "not available yet".
import { useEffect, useState } from "preact/hooks";
import { useApi } from "@nexus/ui";
import { Link } from "@nexus/ui";
import { Card, Chip, StatCard, StatGrid } from "@nexus/ui";
import { Loading } from "@nexus/ui";
import { FLEET_PATH, fleetTile, loadFleet, NO_FLEET_FILTERS, type FleetQuotaStanding } from "../quotas/fleet-model";
import { loadable, NOT_AVAILABLE, type Loadable } from "../quotas/model";

export function QuotaTile() {
  const client = useApi();
  const [state, setState] = useState<Loadable<FleetQuotaStanding>>({ kind: "loading" });
  useEffect(() => {
    let live = true;
    void loadable(() => loadFleet(client, NO_FLEET_FILTERS)).then((next) => live && setState(next));
    return () => {
      live = false;
    };
  }, [client]);

  if (state.kind === "error") return null;
  const tile = state.kind === "loaded" ? fleetTile(state.value) : null;
  return (
    <Card
      title="Quotas"
      help="quotas.fleetTile"
      actions={
        <Link href={FLEET_PATH} class="button-link">
          Open quota standing
        </Link>
      }
    >
      {state.kind === "loading" && <Loading label="Loading quota standing…" rows={1} />}
      {state.kind === "unavailable" && <p class="muted">{NOT_AVAILABLE}</p>}
      {tile && (
        <>
          <StatGrid label="Organizations by quota state">
            {tile.counts.map((count) => (
              <StatCard
                key={count.state}
                label={count.label}
                value={
                  <>
                    {count.orgs.toLocaleString("en-US")}
                    {count.orgs > 0 && <span class="stat-of"> orgs</span>}
                  </>
                }
                note={count.instances > 0 ? <Chip tone={count.tone}>{`${count.instances.toLocaleString("en-US")} in this state`}</Chip> : "None"}
              />
            ))}
          </StatGrid>
          <p class="muted">{tile.summary}</p>
        </>
      )}
    </Card>
  );
}
